// ChangeChip — small pill showing a directional change (gain/loss): an arrow +
// caller-supplied text, tinted by tone. Used for "+4.8% this year" gain
// indicators and "+8.2% YTD" growth chips. Caller formats the text; the chip
// owns the arrow + tone styling only.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import { ArrowRightIcon } from '../../icons/Icons';
import './change-chip.css';

export function ChangeChip({ tone = 'gain', dir = 'up', children, className }) {
  const transform = dir === 'down' ? 'rotate(90deg)' : 'rotate(-90deg)';
  return (
    <span className={cx('change-pill', `change-pill--${tone}`, className)}>
      <ArrowRightIcon width={11} height={11} style={{ transform }} aria-hidden="true" />
      <span className="change-pill__text">{children}</span>
    </span>
  );
}

ChangeChip.propTypes = {
  tone: PropTypes.oneOf(['gain', 'loss', 'neutral']),
  dir: PropTypes.oneOf(['up', 'down']),
  children: PropTypes.node,
  className: PropTypes.string,
};

export default ChangeChip;
